import { apiInstances } from '../../../../libs';

const { get } = apiInstances.routesInstance;

export default async function getRoutesHistory({
  id_clouder,
  page,
  start,
  end,
}) {
  return get(
    `/clouders/${id_clouder}/routes?page=${page}&start=${start}&end=${end}`
  );
}
